import React from 'react';
import { FubDealsIntegrationToggleWrapper } from 'feature-toggle';
import { AccessChecker } from 'authorization-scope';
import { TeamPermission } from 'nekst-api';
import {
  ApplicationSettingsNavigationContext,
  ShadcnExternalLinksList,
} from 'features/tasks-forms';
import SidebarBlock from '../../shared/web/layout/SidebarBlock';
import useSettingsNavigator from '../../settings/settingsNavigator';

export default function ProjectIntegrationsList(props: { projectId: number }) {
  const settingsNavigator = useSettingsNavigator();

  return (
    <FubDealsIntegrationToggleWrapper>
      <AccessChecker permissionToCheck={TeamPermission.READ_FUB_CONNECTION}>
        <ApplicationSettingsNavigationContext openApplicationSettingsFunc={settingsNavigator.openFubProfilesPage}>
          <SidebarBlock title="Integrations" testId="project-integrations">
            <ShadcnExternalLinksList projectId={props.projectId} />
          </SidebarBlock>
        </ApplicationSettingsNavigationContext>
      </AccessChecker>
    </FubDealsIntegrationToggleWrapper>
  );
}
